
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/polaroid-kamera-mieten",
      function () {
        return require("private-next-pages/polaroid-kamera-mieten.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/polaroid-kamera-mieten"])
      });
    }
  